// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSearchToggle_root__1ja8-","input":"InputSearchToggle_input__2FUQ_","inputSearchIcon":"InputSearchToggle_inputSearchIcon__2bRwn"};